<template>
    <div
        v-loading="loading"
        class="py-2">
        <div
            v-if="hasAlert"
            class="mb-4 space-y-2">
            <template
                v-for="(item, index) in alerts"
                :key="index">
                <alert-item
                    :journey="journey"
                    :item="item"
                    :item-index="index"
                    @modify="openModify"
                    @skipped="alertSkipped" />
            </template>
        </div>
        <div v-else>
            <p>
                Hiện tại chưa có cảnh báo.
            </p>
        </div>
    </div>
</template>
<script lang="ts" setup>
import AlertItem from './alert-item.vue'
const props = defineProps({
  journey: {
    type: Object,
    required: true
  }
})

const emits = defineEmits(['modify', 'skipped', 'change'])
const { journey } = toRefs(props)
const journeyId = computed(() => journey.value?.id)
const loading = ref(true)
const alerts = ref([])
const hasAlert = computed(() => Array.isArray(alerts.value) && alerts.value.length > 0)

const getAlerts = () => {
  if (!journeyId.value) {
    return
  }
  alerts.value = []
  loading.value = true
  $api($url.monitoring.journey.alert.get, { uriParams: { ID: journeyId.value }, body: { type: 'SCHEDULE_ALERT' } }).then(({ data }: any) => {
    alerts.value = (data?.value || {}).data || []
    nextTick(() => {
      emits('change', alerts.value.length)
      loading.value = false
    })
  })
}
const openModify = () => {
  emits('modify')
}
onMounted(() => {
  getAlerts()
})
const refresh = $lodash.debounce(getAlerts, 500)
const alertSkipped = (id: string) => {
  emits('skipped')
}
defineExpose({ refresh })
</script>
